function keyPress(e) {
    if (!e) e = window.event;
    if ((e.ctrlKey) && ((e.keyCode === 10) || (e.keyCode === 13))) {
        getText();
    }
    return true;
}

function getText() {
    let text = window.getSelection().toString();
    // let txt = window.getSelection();
    // let selected_text = txt.toString();
    // let full_text = txt.anchorNode.textContent;
    // let selection_start = txt.anchorOffset;
    // let selection_end = txt.focusOffset;
    // console.log(selected_text)
    // console.log(full_text)
    // console.log(selection_start)
    // console.log(selection_end)
    if (text.length < 3) {
        return;
    }
    sendTextError(text);
}

function sendTextError(text) {

    axios
        .post('/mistake', {
            text: text,
            url:window.location.href,
        })
        .then(response => {
            alert(response.data);
        }).catch(error => {
        console.log(error);
    })
    ;
}

document.onkeypress = keyPress;
